/** CUSTOMIZATINOS:
 * -non si vuole mostrare il link al servizio nella testata della pagina
 */

const PageHeaderLinkServizio = ({ content }) => {
  return null;
};

export default PageHeaderLinkServizio;
